import React from 'react';
import ReactDOM from 'react-dom';
import { Suspense } from 'react';
import './index.css';
import Loading from './Components/Loading';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './i18n'

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback = {<Loading />}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
